<template>
  <div>
    <div class="row shippingaddress" :class="billing?'billingaddress':''">
      <div class="col-md-12" v-if="!billing">
        <h3>{{$t('shopping.shipping_address')}}</h3>
      </div>
      <div class="col-md-12 form_item" v-if="address_book">
        <label for="addressoption">Save address</label>
        <div class="selectBox">
          <select name id="addressoption" @change="useaddress" v-model="addressoption">
            <option value="newaddress">{{$t('shopping.new_address')}}</option>
            <option v-for="(item,index) in address_book" :value="JSON.stringify(item)" :key="index">
              {{item.address_1}}
              {{item.address_2}}
              {{item.city}},
              {{item.postcode}}
              <span
                v-html="country_state(item.country,item.state,service)"
              ></span>
              ({{item.first_name}}
              {{item.last_name}}
              {{item.company}})
            </option>
          </select>
          <div class="selectBackground">
            <i class="iconfont icon-ico_arrows_unfold-copy"></i>
          </div>
        </div>
      </div>
      <div
        class="col-md-6 form_item"
        :class="{
        'required':error['shipping.first_name']||error['billing.first_name'],
        'had_input':shipping.first_name
      }"
      >
        <label for="first_name">{{$t('shopping.first_name')}}</label>
        <input
          type="text"
          v-model="shipping.first_name"
          @blur="required"
          @change="allchange"
          id="first_name"
          name="first_name"
          :placeholder="$t('shopping.first_name')"
        />
        <div class="error_mes">{{$t('shopping.enter_first_name')}}</div>
      </div>

      <div
        class="col-md-6 form_item"
        :class="{
        'required':error['shipping.last_name']||error['billing.last_name'],
        'had_input':shipping.last_name
      }"
      >
        <label for="last_name">{{$t('shopping.last_name')}}</label>
        <input
          type="text"
          v-model="shipping.last_name"
          @blur="required"
          id="last_name"
          name="last_name"
          @change="allchange"
          :placeholder="$t('shopping.last_name')"
        />
        <div class="error_mes">{{$t('shopping.enter_last_name')}}</div>
      </div>
      <div
        class="col-md-12 form_item"
        :class="{
        'required':error['shipping.address_1']||error['billing.address_1'],
        'had_input':shipping.address_1
      }"
      >
        <label for="address_1">{{$t('shopping.address')}}</label>

        <input
          v-if="complete=='yes'&& auto_compolete_support.includes(shipping.country) "
          type="text"
          v-model="shipping.address_1"
          @blur="required"
          id="address_1"
          name="address_1"
          @change="allchange"
          @keyup="$refs.autocomplete.searchApi($event,shipping.address_1,shipping.country)"
          @keyup.enter.stop="$refs.autocomplete.keyupEnter"
          @keydown.up.prevent="$refs.autocomplete.keydownUp"
          @keydown.down.prevent="$refs.autocomplete.keydownDown"
          @keyup.esc="$refs.autocomplete.show=false;"
          @click.stop="$refs.autocomplete.show=true;"
          :placeholder="$t('shopping.address')"
          autocomplete="none"
          autocorrect="off"
        />
        <input
          v-else
          type="text"
          v-model="shipping.address_1"
          @blur="required"
          id="address_1"
          name="address_1"
          @change="allchange"
          :placeholder="$t('shopping.address')"
          autocorrect="off"
        />
        <div class="error_mes">{{$t('shopping.enter_address')}}</div>
        <v-autocomplete
          v-if="complete=='yes'&& auto_compolete_support.includes(shipping.country) "
          ref="autocomplete"
          @keyupEnter="keyupEnter"
        ></v-autocomplete>
      </div>
      <div
        v-if="checkout_address_2_config!='hidden'"
        class="col-md-12 form_item"
        :class="{
        'required':error['shipping.address_2']||error['billing.address_2'],
        'had_input':shipping.address_2
      }"
      >
        <label
          for="address_2"
        >{{ checkout_address_2_config=='optional'?$t('shopping.enter_apartment_optional'):$t('shopping.enter_apartment_need') }}</label>
        <input
          type="text"
          v-model="shipping.address_2"
          @blur="checkout_address_2_config=='required'&&required($event)"
          id="address_2"
          name="address_2"
          @change="allchange"
          :placeholder="checkout_address_2_config=='optional'? $t('shopping.enter_apartment_optional') : $t('shopping.enter_apartment_need')"
        />
        <div class="error_mes">{{$t('shopping.enter_apartment')}}</div>
      </div>
      <div
        class="col-md-12 form_item"
        :class="{
        'required':error['shipping.city']||error['billing.city'],
        'had_input':shipping.city
      }"
      >
        <label for="city">{{$t('shopping.city')}}</label>
        <input
          type="text"
          v-model="shipping.city"
          @blur="required"
          id="city"
          name="city"
          @change="allchange"
          :placeholder="$t('shopping.city')"
        />
        <div class="error_mes">{{$t('shopping.enter_city')}}</div>
      </div>
      <!-- <div
        class="form_item"
        :class="{'col-md-6':province.length==0&&!support_enter_state.includes(shipping.country),'col-md-4':province.length!=0||support_enter_state.includes(shipping.country),'required':error['shipping.country']||error['billing.country'],'had_input':shipping.country}"
      > -->
      <div
        class="form_item"
        :class="{ 'col-md-12':province.length==0&&no_postcode.includes(shipping.country), 
        'col-md-6':province.length==0||no_postcode.includes(shipping.country),
        'col-md-4':province.length!=0&&!no_postcode.includes(shipping.country),'required':error['shipping.country']||error['billing.country'],'had_input':shipping.country}"
      >
        <div class="selectBox">
          <label for="country" style="top:4px;left:12px">{{$t('shopping.country')}}</label>
          <select
            autocomplete="country"
            id="country"
            name="country"
            v-model="shipping.country"
            @change="changecountry($event),allchange()"
          >
            <option value disabled selected>Country</option>
            <option :value="item.code" v-for="item in service" :key="item.code" v-html="item.name"></option>
          </select>
          <div class="selectBackground">
            <i class="iconfont icon-ico_arrows_unfold-copy"></i>
          </div>
        </div>
        <div class="error_mes">Select country</div>
      </div>
      <div
        class="had_input form_item"
        v-if="province.length"
        :class="{
          'col-md-4':!no_postcode.includes(shipping.country), 
          'col-md-6':no_postcode.includes(shipping.country),
          'required':error['shipping.state']||error['billing.state'],
      }"
      >
        <div class="selectBox">
          <label for="state" style="top:4px;left:12px">{{$t('shopping.province')}}</label>
          <select
            name="state"
            id="state"
            v-model="shipping.state"
            @change="required($event),allchange()"
          >
            <option value disabled selected>Province</option>
            <option :value="item.code" v-for="item in province" :key="item.code" v-html="item.name"></option>
          </select>
          <div class="selectBackground">
            <i class="iconfont icon-ico_arrows_unfold-copy"></i>
          </div>
        </div>
        <div class="error_mes">Select a state / province</div>
      </div>
      <!-- <div
        class="col-md-4  form_item"
        v-if="!province.length&&support_enter_state.includes(shipping.country)"
        :class="{
        'had_input':shipping.state,
        'required':error['shipping.state']||error['billing.state']
      }"
      >
        <label for="state">Province</label>
        <input
          type=" text"
          v-model="shipping.state"
          @blur="required"
          id="state"
          name="state"
          @change="allchange"
          placeholder="Province"
        />
        <div class="error_mes">Enter a state / province</div>
      </div> -->
      <!-- <div
        class="form_item"
        :class="{'col-md-6':province.length==0&&!support_enter_state.includes(shipping.country),'col-md-4':province.length!=0||support_enter_state.includes(shipping.country),'required':error['shipping.postcode']||error['billing.postcode'],'had_input':shipping.postcode}"
      > -->
      <div
        v-if="!no_postcode.includes(shipping.country)"
        class="form_item"
        :class="{'col-md-6':province.length==0,'col-md-4':province.length!=0,'required':error['shipping.postcode']||error['billing.postcode'],'had_input':shipping.postcode}"
      >
        <label for="postcode">{{$t('shopping.postcode')}}</label>
        <input
          type=" text"
          v-model="shipping.postcode"
          @blur="required"
          id="postcode"
          name="postcode"
          @change="allchange"
          :placeholder="$t('shopping.postcode')"
        />
        <div class="error_mes">{{$t('shopping.enter_postcode')}}</div>
      </div>

      <div
        class="col-md-12 phone"
        :class="{
        'required':error['shipping.phone']||error['billing.phone'],
        'had_input':shipping.phone
      }"
        v-if="checkout_phone_config!='hidden'"
      >
        <vue-phone-number-input
          v-model="phone"
          :no-country-selector="true"
          no-example
          id="phone"
          name="phone"
          :default-country-code="shipping.country"
          :translations="{phoneNumberLabel: checkout_phone_config=='optional'? $t('shopping.phone_optional'):$t('shopping.phone_need'),}"
          @phone-number-blur="checkout_phone_config=='required'&&testphone(shipping.phone)"
          @update="transformphone"
        ></vue-phone-number-input>
        <el-tooltip class="item" effect="dark" placement="top" transition="abc">
          <div slot="content" class="text-center">
            {{$t('shopping.in_case_we_need_to_contact')}}
            <br />{{$t('shopping.about_your_order')}}
          </div>
          <button class="phonetitle iconfont icon-wenhao1"></button>
        </el-tooltip>
        <div class="error_mes">{{$t('shopping.enter_number')}}</div>
      </div>
      <!-- <div
        class="col-md-12 form_item"
        :class="{
        'required':error['shipping.phone'],
        'had_input':shipping.phone
      }"
        v-if="checkout_phone_config!='hidden'"
      >
        <label for="phone">{{checkout_phone_config=='optional'? 'Phone (optional)':'Phone'}}</label>
        <input
          type="text"
          v-model="shipping.phone"
          id="phone"
          @change="allchange"
          @blur="checkout_phone_config=='required'&&testphone()"
          :placeholder="checkout_phone_config=='optional'? 'Phone (optional)':'Phone'"
        />
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content" class="text-center">
            In case we need to contact
            <br />you about your order
          </div>
          <button class="phonetitle iconfont icon-wenhao1"></button>
        </el-tooltip>
        <div>Enter a valid phone number</div>
      </div>-->
      <div class="col-md-12 keepup" v-if="!user&&!billing">
        <label>
          <input type="checkbox" v-model="Save_infor" />
          <div
            :class="Save_infor?'iskeepup':''"
            class="iconfont icon-confirm-line"
            style="font-weight:600;"
          ></div>
          <span>{{$t('shopping.save_info_next')}}</span>
        </label>
      </div>
    </div>
    <!-- <div class="addressfoot">
      <div class="row flex-row-reverse justify-content-between">
        <div class="col-md-5 col-lg-6 text-center">
          <el-button @click="toshipping" :loading="loading">{{to}}</el-button>
        </div>
        <div class="col-md-4 text-md-left text-center">
          <a href="/cart">&lt; Return to cart</a>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
import API from "../../../API.js";
//引入vue-phone-number-input
import VuePhoneNumberInput from "vue-phone-number-input";
import autocomplete from "./autocomplete.vue";
// import "vue-phone-number-input/dist/vue-phone-number-input.css" //样式可不引入;

export default {
  props: [
    "service",
    "cart",
    "address_book",
    "user",
    "checkout_address_2_config",
    "checkout_phone_config",
    "addressBook",
    "information",
    "complete",
    "billing",
  ],
  data() {
    return {
      province: [],
      phone: "", //经过组件改变后的phone，还需要去除非数字项才能绑定到shipping.phone
      shipping: {
        first_name: "",
        last_name: "",
        city: "",
        country: "",
        state: "",
        postcode: "",
        address_1: "",
        address_2: null,
        phone: null,
        email: "",
      },
      error: {
        "shipping.first_name": "",
        "shipping.last_name": "",
        "shipping.address_1": "",
        "shipping.address_2": "",
        "shipping.city": "",
        "shipping.postcode": "",
        "shipping.phone": "",
        "shipping.state": "",
        "shipping.country": "",
      },
      test: [
        "first_name",
        "last_name",
        "address_1",
        "city",
        "state",
        "country",
        "postcode",
      ],
      focusOff: true,
      Save_infor: false,
      addressoption: "newaddress",
      auto_compolete_support: [
        "IN", //印度
        "AU", //澳大利亚
        "CA", //加拿大
        "ZA", //南非
        "GB", //英国
        "LB", //黎巴嫩
        "FR", //法国
        "PS", //巴勒斯坦
        "PR", //波多黎各
        "DE", //德国
        "TW", //台湾
        "MO", //澳门
        "HK", //香港
        "NP", //尼泊尔
        "ID", //印度尼西亚
        "TR", //土耳其
        "IE", //爱尔兰
        "JP", //日本
        "CN",
        "US",
      ],
      support_enter_state:["CL","CO","EG","GT","PA","PT","RU","KR"],
      no_postcode:["AO","AI","AG","AE","AW","BS","BZ","BJ","BO","BF","TD","FJ","HK","JM","MW","ML","PA","QA","TG","UG","VU","ZW","CW","SS","TT","TV","YE"],
      no_state:["AO","BD","BO","BG","GR","HU","IR","LR","MD","NP","PK","PY","PH","CH","TZ","TR","UG","ZM"],
    };
  },
  methods: {
    keyupEnter(e) {
      if (e.address != "") {
        this.shipping.address_1 = e.address;
      }
      if (e.address1 != "") {
        this.shipping.address_2 = e.address1;
      }
      if (e.city != "") {
        this.shipping.city = e.city;
      }
      if (e.province_code != "") {
        this.shipping.state = e.province_code;
      }
      if (e.postal_code != "") {
        this.shipping.postcode = e.postal_code;
      }
    },
    //转换电话号码，将非数字剔除
    transformphone(e) {
      this.shipping.phone = e.phoneNumber
        ? e.phoneNumber.replace(/[\D]/g, "")
        : "";
    },
    // 改变任意地址信息的时候selection变成使用新地址
    allchange() {
      this.addressoption = "newaddress";
      this.$emit("upAddressBook", "newaddress");
    },
    //判断有没有省份
    isProvince(country) {
      this.service.some((item) => {
        if (item.code == country) {
          this.province = item.states;
          if(this.no_state.includes(country)){
           this.province = [];
          };
          if( this.no_postcode.includes(country)&& this.test.includes("postcode")){
            this.test.splice(this.test.indexOf("postcode"), 1);
            this.shipping.postcode="";
          }else if(!this.no_postcode.includes(country)&& !this.test.includes("postcode")){
            this.test.push("postcode");
          }
          // if ((this.province.length||this.support_enter_state.includes(country)) && !this.test.includes("state")) {
          //   this.test.push("state");
          // } else if ((!this.province.length&&!this.support_enter_state.includes(country)) && this.test.includes("state")) {
          //   this.test.splice(this.test.indexOf("state"), 1);
          // }
          if (this.province.length && !this.test.includes("state")) {
            this.test.push("state");
          } else if (!this.province.length&& this.test.includes("state")) {
            this.test.splice(this.test.indexOf("state"), 1);
          }
        }
      });
    },
    // 改变地址薄的是时候判断是使用新地址还是已保存的地址
    useaddress(e) {
      if (this.addressoption == "newaddress") {
        this.shipping = {
          first_name: "",
          last_name: "",
          city: "",
          country: this.$store.state.country,
          state: "",
          postcode: "",
          address_1: "",
          address_2: null,
          phone: "",
        };
        this.isProvince(this.$store.state.country);
        this.phone = "";
        this.$emit("upAddressBook", "newaddress");
      } else {
        this.$emit("upAddressBook", this.addressoption);
        let value = JSON.parse(this.addressoption);
        this.shipping.address_1 = value.address_1;
        this.shipping.address_2 = value.address_2;
        this.shipping.city = value.city;
        this.shipping.postcode = value.postcode;
        this.shipping.phone = value.phone;
        this.shipping.last_name = value.last_name;
        this.shipping.first_name = value.first_name;
        this.shipping.state = value.state;
        this.shipping.country = value.country;
        this.shipping.email = value.email;
        this.phone = this.shipping.phone;
        this.isProvince(this.shipping.country);
      }
    },
    // 改变国家
    changecountry(e) {
      if (e.target.value) {
        this.$(e.target.parentNode).removeClass("errormes");
        this.$(e.target.parentNode).removeClass("required");
      } else {
        this.$(e.target.parentNode).addClass("required");
      }
      this.error["shipping.state"] = "";
      this.shipping.state = "";
      this.isProvince(e.target.value);
    },
    //验证电话号码
    testphone() {
      // if (!/\d{8,}$/.test(this.shipping.phone) {
      if (!this.shipping.phone) {
        this.$("#phone").parent().addClass("required");
        this.focusMethod("phone");
        return false;
      } else {
        this.$("#phone").parent().removeClass("required");
        return true;
      }
    },
    required(e) {
      if (e.target.value.trim() == "") {
        if (e.target.id != "state") {
          this.$(e.target.parentNode).addClass("required");
        }
      } else {
        this.$(e.target.parentNode).removeClass("errormes");
        this.$(e.target.parentNode).removeClass("required");
      }
    },
    //表单验证错误时聚焦到第一个错误的地方，onOFF为开关
    focusMethod(ID) {
      if (this.focusOff) {
        if (ID != "phone") {
          this.$("#" + ID).focus();
        } else {
          this.$('[placeholder="Phone"]')[0].focus();
        }
      }
      this.focusOff = false;
    },
    toshipping() {
      let reg = /^([0-9A-Za-z\-_\.]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      // 有一项为空的话就不能发请求
      let value = true;
      this.focusOff = true;
      console.log("表单验证项", this.test);
      console.log(654646, this.shipping);
      this.test.forEach((item) => {
        if (
          item == "email" &&
          (!reg.test(this.shipping.email) || this.shipping.email == "")
        ) {
          this.$emit("emailrequired");
          value = false;
          this.focusMethod("email");
        } else if (!this.shipping[item]) {
          this.$("#" + item)
            .parent()
            .addClass("required");
          value = false;
          this.focusMethod(item);
        }
      });
      return value;
    },
    //地址薄获取省和国家的格式
    country_state(country, state, service) {
      let res = null;
      service.some((item) => {
        // 第一层判断国家代码
        if (item.code == country) {
          // 判断国家代码正确。判断是否有省
          if (item.states.length) {
            item.states.some((subitem) => {
              if (subitem.code == state) {
                res = subitem.name + "," + item.name;
                return true;
              }
            });
          } else {
            // 没有省res直接等于国家名 return出去
            res = item.name;
            return true;
          }
        }
      });
      return res;
    },
    //验证省份格式是否正确
    test_state() {
      if (this.province.length && this.shipping.state) {
        let res = this.province.some((item) => {
          return item.code == this.shipping.state;
        });
        if (!res) {
          this.shipping.state = "";
        }
       } // else if(!this.support_enter_state.includes(this.shipping.country)) {
      //   //如果没有省份长度清空state
      //   this.shipping.state = "";
      // }
    },
  },
  beforeMount() {
    this.addressoption = this.addressBook;
    this.shipping = this.information;
    if(this.$store.state.country!==null&&(this.shipping&&!this.shipping.country)){
        this.shipping.country=this.$store.state.country;
    }
    // this.shipping.address_1 = this.information.address_1;
    // this.shipping.address_2 = this.information.address_2;
    // this.shipping.city = this.information.city;
    // this.shipping.postcode = this.information.postcode;
    // this.shipping.phone = this.information.phone;
    // this.shipping.last_name = this.information.last_name;
    // this.shipping.first_name = this.information.first_name;
    // this.shipping.state = this.information.state;
    // this.shipping.country = this.information.country;
    // this.shipping.email = this.information.email;
    console.log("email", this.shipping.state);
    this.phone = this.shipping.phone;
  },
  mounted() {
    console.log("complete", this.complete);
    //若没登录则邮箱也是必填的
    let testaddress_2 = 3;
    if (!this.user && !this.billing) {
      this.test.unshift("email");
      testaddress_2 = 4;
    }
    //若电话为必填则加上验证项目，若为隐藏要清空之前填过的电话
    if (this.checkout_phone_config == "required") {
      this.test.push("phone");
    } else if (this.checkout_phone_config == "hidden") {
      this.phone = "";
      this.shipping.phone = "";
    }
    //若address2为必填则加上验证项目，若为隐藏要清空之前填过的address2
    if (this.checkout_address_2_config == "required") {
      this.test.splice(testaddress_2, 0, "address_2");
    } else if (this.checkout_address_2_config == "hidden") {
      this.shipping.address_2 = null;
    }
    // 将用户所选的国家的省份赋值给this.province
    this.isProvince(this.shipping.country);
    if (window.performance.navigation.type == 2) {
     let href= window.location.href;
     let address=null;
      if(href.includes('information')){
         address=sessionStorage.getItem('address');
      }else if(href.includes('payment')){
         address=sessionStorage.getItem('billingAddress');
      }
      if(address){
        console.log(address);
        address=JSON.parse(address);
        this.isProvince(address.country);
        console.log('window.performance.navigation.type == 2',address.country);
      }
    }
    //如果获取到的state不符合省份的格式要求则把他置空,让用户重新选择
    this.test_state();
  },
  watch: {
    shipping: {
      handler(newV, oldV) {
        this.$emit("updataShipping", newV);
      },
      deep: true,
    },
    "shipping.state": {
      handler(newV, oldV) {
        this.test_state();
      },
      deep: true,
    },
    "shipping.phone": {
      handler(newV, oldV) {
        this.phone = newV;
      },
      deep: true,
    },
    "$store.state.country"(newV) {
      if ((this.billing&&!this.billing.country)||(this.shipping&&!this.shipping.country)) {
        console.log('this.$store.state.country');
        this.shipping.country = newV;
        this.isProvince(newV);
      }
    },
  },
  components: {
    "vue-phone-number-input": VuePhoneNumberInput,
    "v-autocomplete": autocomplete,
  },
};
</script>
<style  scope lang='scss'>
.billingaddress {
  padding-top: 0px !important;
}
.shippingaddress {
  padding-top: 42px;
  margin-left: -6px;
  margin-right: -6px;

  h3 {
    color: #333;
    font-size: 18px;
    margin-left: -10px;
  }
  & > .phone {
    padding: 6px;
    #phone {
      position: relative;
      input {
        width: 100% !important;
        font-size: 13px !important;
        height: 46px !important;
        padding: 13px 11px;
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px !important;
        caret-color: black !important;
        outline: none;
        color: #333333;

        &:focus {
          box-shadow: 0 0 0 1px #128fae !important;
          border-color: #128fae !important;
        }
      }
      label {
        color: #333333 !important;
        display: none;
        font-size: 12px;
        position: absolute;
        top: 4px;
        left: 12px;
      }
    }
    .error_mes {
      font-size: 14px;
      color: #e32c2b;
      display: none !important;
    }
    .phonetitle {
      position: absolute;
      top: 16px;
      right: 6px;
      border: none;
      background: rgba(255, 255, 255, 0);
      padding: 0 10px;
      height: 26px;
      line-height: 26px;
      color: #919191;
      font-size: 20px;
    }
  }

  & > .form_item {
    padding: 6px;
    position: relative;

    & > .error_mes {
      font-size: 14px;
      color: #e32c2b;
      display: none;
    }

    select,
    input {
      color: #333333;
      width: 100%;
      font-size: 13px;
      height: 46px;
      padding: 13px 11px;
      border: 1px solid #d9d9d9;
      border-radius: 5px;
    }
    select {
      position: relative;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: #fff;
      padding-right: 30px;
      option {
        background-color: #fff;
      }
    }
    .selectBox {
      position: relative;
      .selectBackground {
        position: absolute;
        top: 50%;
        right: 1px;
        width: 31px;
        height: 20px;
        border-left: 1px rgba(179, 179, 179, 0.5) solid;
        text-align: center;
        transform: translateY(-50%);
        pointer-events: none;
        i {
          color: #919191;
          vertical-align: middle;
          line-height: 100%;
          font-size: 15px;
        }
      }
    }

    select:focus,
    input:focus {
      outline: none;
      box-shadow: 0 0 0 1px #128fae !important;
      border-color: #0f88a7;
      border-radius: 5px;
    }

    label {
      color: #333333;
      display: none;
      font-size: 12px;
      position: absolute;
      top: 4px;
      left: 12px;
      z-index: 10;
    }

    // i {
    //   font-size: 12px;
    //   position: absolute;
    //   top: 20px;
    //   right: 20px;
    //   cursor: default;
    // }
  }
  .required {
    select,
    input,
    #phone .flex-1 .input-tel input {
      border-color: #e32c2b !important;
      box-shadow: 0 0 0 1px #e32c2b !important;
      &:focus {
        box-shadow: 0 0 0 1px #e32c2b !important;
        border-color: #e32c2b;
      }
    }

    & > .error_mes {
      display: block !important;
    }
  }
  & > .had_input {
    select,
    input {
      padding: 21px 29px 5px 11px !important;
      font-size: 12px !important;
    }
    label {
      display: inline-block !important;
    }
  }
  .keepup {
    padding: 6px;
    label {
      cursor: pointer;
      span {
        font-size: 14px;
        color: #545454;
        line-height: 17px;
      }
    }

    div {
      display: inline-block;
      width: 17px;
      height: 17px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      line-height: 17px;
      text-align: center;
      color: white;
      font-size: 13px;
    }

    .iskeepup {
      background: #0f88a7;
      border: 1px solid #0f88a7;
    }

    input {
      display: none;
    }
  }
}

@media screen and(max-width:767px) {
  .shippingaddress {
    padding-top: 20px !important;
  }
}
.abc-enter-to,
.abc-leave {
  transition: all 0.2s linear;
  opacity: 1;
  transform: scale(1);
}

.abc-enter,
.abc-leave-to {
  transition: all 0.2s linear;
  opacity: 0;
  transform: scale(0.8);
}
</style>